import ApiService from "./api.service";
import store from "../store/mainStore"

class SettingsService extends ApiService {
    setVotingChartType(data) {
        return this.post(`api/meeting/settings/setVotingChartType`, data);
    }

    setLogoSetting(data) {
        return this.post(`api/meeting/settings/setLogoSetting`, data);
    }

    setLogoClientImage(data) {
        return this.post(`api/meeting/settings/setLogoClientImage`, data);
    }

    async getLogoClientImage() {
        let response = await this.get(`api/meeting/settings/getLogoClientImage`);

        if(response.status !== 200 && response.status !== 204)
        {
            throw await Promise.reject(response);
        }

        if(response.status === 200){
            store.commit("setLogoBase64", response.data.image);
        }

        return response
    }

    getFooterClientImage() {
        return this.get(`api/meeting/settings/getFooterClientImage`);
    }

    deleteLogoClientImage() {
        return this.delete(`api/meeting/settings/deleteLogoClientImage`);
    }

    deleteFooterClientImage() {
        return this.delete(`api/meeting/settings/deleteFooterClientImage`);
    }

    setFooterClientImage(data) {
        return this.post(`api/meeting/settings/setFooterClientImage`, data);
    }

    setCameraApiAddress(data) {
        return this.post(`api/meeting/settings/setCameraApiAddress`, data);
    }

    async getClientType() {
        let response = await this.get(`api/meeting/settings/getClientType`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await store.commit("setClientTypeConfiguration", response.data);
        return response;
    }

    getIntegrationAuthData() {
        return this.get(`api/meeting/settings/getIntegrationAuthData`);
    }

    async updateClientSettings(data)
    {
        let response = await this.post(`api/meeting/settings/update-client-settings`, data);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await this.getUserSettings();
        await this.getRuntimeSettings();
        await store.commit("setClientSettings", response.data);

        return response;
    }

    async updateUserVotingSettings(data)
    {
        let response = await this.post(`api/meeting/settings/update-user-voting-settings`, data);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await this.getClientSettings();
        await this.getRuntimeSettings();
        await store.commit("setUserSettings", response.data);

        return response;
    }

    async getClientSettings(){
        let response = await this.get(`api/meeting/settings/client-settings`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await store.commit("setClientSettings", response.data);
        await this.getVotingAllowedIp();
        return response;
    }

    async getUserSettings(){
        let response = await this.get(`api/meeting/settings/user-settings`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await store.commit("setUserSettings", response.data);
        await this.getVotingAllowedIp();
        return response;
    }

    async getRuntimeSettings(){
        let response = await this.get(`api/meeting/settings/runtime-settings`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await store.commit("setRuntimeSettings", response.data);
        await this.getVotingAllowedIp();
        return response;
    }

    async getVotingAllowedIp() {
        let response = await this.get(`api/meeting/settings/voting-allowed-ip`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await store.commit("setAllowIpAddress", response.data);
        return response;
    }

    async setVotingAllowedIp(ip) {
        let response = await this.post(`api/meeting/settings/voting-allowed-ip`, {
            allowedIp: ip
        });

        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        return await this.getVotingAllowedIp();
    }
}

export default new SettingsService();
